import axios from "axios";

export const flightApi = axios.create({
    baseURL: process.env.REACT_APP_FIDS_BASE_URL,
    headers: {
        'Timezone': 'Asia/Kuala_Lumpur',
        'Content-Type': 'application/json',
    },
});